import React from 'react';
import { View } from '@amzn/stencil-react-components/layout';
import { Text } from '@amzn/stencil-react-components/text';
import AmazonLogoImage from '../../images/Amazon.svg';
import AtoZLogoImage from '../../images/AtoZ.svg';

interface ConsentHeaderProps {}

export const ConsentHeader: React.FC<ConsentHeaderProps> = () => {
  return (
    <>
      {/* Live region for announcements */}
      <div 
        id="live-region" 
        aria-live="polite" 
        aria-atomic="true" 
        className="sr-only"
        role="status"
      />
      
      <header
        role="banner"
        style={{ 
          width: '100%',
          backgroundColor: 'white', 
          borderBottom: '1px solid #e0e0e0',
          position: 'sticky',
          top: 0,
          zIndex: 100,
          boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
        }}
      >
        {/* Desktop Layout */}
        <View 
          style={{ 
            width: '100%',
            padding: '1rem 2rem',
            display: 'flex',
            alignItems: 'center',
            position: 'relative',
            minHeight: '64px'
          }}
          className="consent-header-desktop"
        >
          {/* Left - Amazon Logo */}
          <View style={{ 
            flex: '0 0 auto', 
            display: 'flex', 
            alignItems: 'center', 
            position: 'relative',
            height: '32px'
          }}>
            <img 
              src={AmazonLogoImage}
              alt="Amazon - Investigation Consent Service"
              height="24"
              width="auto"
              style={{ display: 'block' }}
            />
            <img 
              src={AtoZLogoImage}
              alt="A to Z - Everything from A to Z"
              height="14"
              width="auto"
              style={{ 
                marginLeft: '4px',
                marginTop: '-6px'
              }}
            />
          </View>
          
          {/* Center - Provide your consent */}
          <View style={{ 
            position: 'absolute',
            left: '50%',
            transform: 'translateX(-50%)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            height: '32px'
          }}>
            <Text style={{
              color: '#232F3E',
              fontFamily: '"Amazon Ember"',
              fontSize: '16px',
              fontStyle: 'normal',
              fontWeight: '700',
              lineHeight: '21px',
              margin: 0,
              padding: 0
            }}>
              Provide your consent
            </Text>
          </View>
        </View>

        {/* Mobile Layout */}
        <View 
          style={{ 
            width: '100%',
            padding: '0.75rem 1rem',
            display: 'none',
            flexDirection: 'row',
            alignItems: 'center',
            justifyContent: 'space-between',
            minHeight: '48px'
          }}
          className="consent-header-mobile"
        >
          {/* Amazon Logo */}
          <View style={{ 
            display: 'flex', 
            alignItems: 'center', 
            position: 'relative',
            flex: '0 0 auto'
          }}>
            <img 
              src={AmazonLogoImage}
              alt="Amazon - Investigation Consent Service"
              height="20"
              width="auto"
              style={{ display: 'block' }}
            />
            <img 
              src={AtoZLogoImage}
              alt="A to Z - Everything from A to Z"
              height="12"
              width="auto"
              style={{ 
                marginLeft: '3px',
                marginTop: '-5px'
              }}
            />
          </View>
          
          {/* Provide your consent */}
          <View style={{
            flex: '1',
            display: 'flex',
            justifyContent: 'center',
            paddingLeft: '1rem'
          }}>
            <Text style={{
              color: '#232F3E',
              fontFamily: '"Amazon Ember"',
              fontSize: '14px',
              fontStyle: 'normal',
              fontWeight: '700',
              lineHeight: '18px',
              margin: 0,
              padding: 0,
              textAlign: 'center'
            }}>
              Provide your consent
            </Text>
          </View>
        </View>
      </header>
    </>
  );
};

export default ConsentHeader;
